module.exports = __webpack_public_path__ + "media/ich.439b067c.wav";